import React from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faShieldAlt,
  faHandshake,
  faBus,
  faComments,
  faBolt,
  faCircleCheck,
  faFileSignature,
  faGavel
} from "@fortawesome/free-solid-svg-icons";
import CarruselNoticias from "../components/Noticias/CarruselNoticias";
import "../styles/home.modern.css";

const Home = () => {
  return (
    <div className="home-hero-wrapper" role="main" aria-label="Inicio SINTEREC">
      {/* HERO */}
      <section className="home-hero">
        {/* shapes decorativas (suaves y grises) */}
        <span className="shape shape-1" aria-hidden />
        <span className="shape shape-2" aria-hidden />
        <span className="shape shape-3" aria-hidden />

        <Container>
          <Row className="align-items-center">
            <Col lg={7} className="mb-4 mb-lg-0">
              <Badge bg="light" text="dark" className="mb-3 shadow-sm rounded-pill">
                Sindicato Interempresa de Telecomunicaciones — <strong>SINTEREC</strong>
              </Badge>

              <h1 className="hero-title">
                <span className="gradient-text">SINTEREC CLARO</span>
              </h1>

              <p className="hero-sub">
                Representamos a las y los trabajadores del sector telecomunicaciones. Defendemos
                derechos laborales, negociamos colectivamente y promovemos beneficios reales para
                nuestras socias y socios.
              </p>

              <div className="d-flex flex-wrap gap-2">
                <Link to="/login" className="btn btn-hero">
                  <FontAwesomeIcon icon={faCircleCheck} className="me-2" />
                  Iniciar sesión
                </Link>

                <Link to="/directiva-sindicato" className="btn btn-hero-alt">
                  <FontAwesomeIcon icon={faComments} className="me-2" />
                  Escribenos
                </Link>

                <Link to="/preguntas-frecuentes" className="btn btn-hero-alt">
                  <FontAwesomeIcon icon={faFileSignature} className="me-2" />
                  Preguntas frecuentes
                </Link>
              </div>

              <div className="admin-note mt-3">
                <FontAwesomeIcon icon={faGavel} className="me-2" aria-hidden />
                <span>
                  <strong>Registro de socios:</strong> exclusivo para administración. La gestión
                  de nuevas afiliaciones es realizada únicamente por la directiva.
                </span>
              </div>
            </Col>

            <Col lg={5}>
              <Card className="glass-card hero-card text-center p-4">
                <img
                  src="https://api.sinterec.cl/public/images/SINTEREC_logo.jpg"
                  alt="Logo SINTEREC"
                  className="img-fluid mx-auto d-block"
                />
                <small className="text-muted d-block mt-2">
                  Unidad, transparencia y respaldo sindical.
                </small>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      <CarruselNoticias />
      {/* ACCESOS RÁPIDOS */}
      <section className="quick-links">
        <Container>
          <Row className="g-3">
            <Col md={3} sm={6}>
              <Card className="tile-card card-red-strong">
                <Card.Body className="d-flex align-items-center">
                  <div className="icon-circle me-3">
                    <FontAwesomeIcon icon={faShieldAlt} />
                  </div>
                  <div>
                    <div className="tile-title">Convenios</div>
                    <div className="tile-sub">Detalles</div>
                  </div>
                </Card.Body>
                <Card.Footer className="bg-transparent border-0 pt-0">
                  <Link to="/convenios" className="stretched-link" aria-label="Ir a convenios" />
                </Card.Footer>
              </Card>
            </Col>

            <Col md={3} sm={6}>
              <Card className="tile-card card-red-strong">
                <Card.Body className="d-flex align-items-center">
                  <div className="icon-circle me-3">
                    <FontAwesomeIcon icon={faBolt} />
                  </div>
                  <div>
                    <div className="tile-title">Beneficios</div>
                    <div className="tile-sub">Revisa Nuestros Beneficios</div>
                  </div>
                </Card.Body>
                <Card.Footer className="bg-transparent border-0 pt-0">
                  <Link to="/beneficios" className="stretched-link" aria-label="Ir a beneficios" />
                </Card.Footer>
              </Card>
            </Col>

            <Col md={3} sm={6}>
              <Card className="tile-card card-red-strong">
                <Card.Body className="d-flex align-items-center">
                  <div className="icon-circle me-3">
                    <FontAwesomeIcon icon={faUsers} />
                  </div>
                  <div>
                    <div className="tile-title">Directiva del Sindicato</div>
                    <div className="tile-sub">Quiénes somos</div>
                  </div>
                </Card.Body>
                <Card.Footer className="bg-transparent border-0 pt-0">
                  <Link to="/directiva-sindicato" className="stretched-link" aria-label="Ir a directiva del sindicato" />
                </Card.Footer>
              </Card>
            </Col>

            <Col md={3} sm={6}>
              <Card className="tile-card card-red-strong">
                <Card.Body className="d-flex align-items-center">
                  <div className="icon-circle me-3">
                    <FontAwesomeIcon icon={faComments} />
                  </div>
                  <div>
                    <div className="tile-title">FAQ</div>
                    <div className="tile-sub">Preguntas Frecuentes</div>
                  </div>
                </Card.Body>
                <Card.Footer className="bg-transparent border-0 pt-0">
                  <Link to="/preguntas-frecuentes" className="stretched-link" aria-label="Ir a preguntas frecuentes" />
                </Card.Footer>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ¿POR QUÉ SINTEREC? */}
      <section className="features">
        <Container>
          <h2 className="section-title mb-3">¿Por qué SINTEREC?</h2>
          <p className="section-sub">
            Acompañamos a las y los trabajadores con <strong>asesoría, defensa y comunidad</strong>.
          </p>

          <Row className="g-3">
            <Col md={4}>
              <Card className="feature-card card-red">
                <Card.Body>
                  <div className="icon-wrap">
                    <FontAwesomeIcon icon={faShieldAlt} />
                  </div>
                  <h5 className="mt-3 mb-1">Defensa y respaldo</h5>
                  <p className="m-0">
                    Representación frente a contingencias laborales y asesoría legal.
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="feature-card card-red">
                <Card.Body>
                  <div className="icon-wrap">
                    <FontAwesomeIcon icon={faHandshake} />
                  </div>
                  <h5 className="mt-3 mb-1">Negociación colectiva</h5>
                  <p className="m-0">
                    Mejores condiciones y procesos de evaluación justos.
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="feature-card card-red">
                <Card.Body>
                  <div className="icon-wrap">
                    <FontAwesomeIcon icon={faUsers} />
                  </div>
                  <h5 className="mt-3 mb-1">Comunidad</h5>
                  <p className="m-0">
                    Espacios de encuentro e iniciativas para el bienestar.
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="feature-card card-red-invert">
                <Card.Body>
                  <div className="icon-wrap">
                    <FontAwesomeIcon icon={faBolt} />
                  </div>
                  <h5 className="mt-3 mb-1">Beneficios</h5>
                  <p className="m-0">
                    Acceso a convenios y descuentos para ti y tu familia.
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="feature-card card-red-invert">
                <Card.Body>
                  <div className="icon-wrap">
                    <FontAwesomeIcon icon={faFileSignature} />
                  </div>
                  <h5 className="mt-3 mb-1">Apoyo en trámites</h5>
                  <p className="m-0">Acompañamiento en documentación y gestión informativa.</p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="feature-card card-red-invert">
                <Card.Body>
                  <div className="icon-wrap">
                    <FontAwesomeIcon icon={faBus} />
                  </div>
                  <h5 className="mt-3 mb-1">Atención cercana</h5>
                  <p className="m-0">Canales de contacto claros y respuestas oportunas.</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA / ACCESO */}
      <section className="cta">
        <Container>
          <Row className="align-items-center">
            <Col md={8}>
              <h3 className="cta-title">Acceso a la plataforma</h3>
              <p className="cta-sub m-0">
                Si aún no tienes acceso y eres trabajadora/or habilitada/o, comunícate con la
                <strong> Directiva</strong> para tu alta.
              </p>
            </Col>
            <Col md={4} className="text-md-end mt-3 mt-md-0">
              <Link to="/login" className="btn btn-hero">
                <FontAwesomeIcon icon={faCircleCheck} className="me-2" />
                Iniciar sesión
              </Link>
            </Col>
          </Row>
        </Container>
      </section>

      {/* MINI FOOTER LOCAL (el footer general del sitio sigue en rojo/blanco) */}
      <footer className="home-footer">
        <Container>
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
            <small className="text-muted">
              © {new Date().getFullYear()} SINTEREC CLARO. Todos los derechos reservados.
            </small>
            <small className="text-muted">
              Hecho con <span aria-label="corazón">❤️</span> por el sindicato.
            </small>
          </div>
        </Container>
      </footer>
    </div>
  );
};

export default Home;
